var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo"},[_c('img',{attrs:{"src":require("@/assets/logo-hangyang.png"),"width":"64px","height":"40px"}}),(_vm.showTitle)?_c('h1',[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }